import { Grid, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import FeedsService from "../../services/feedService";
import ChatList from "./ChatList";
import SendMessage from "./SendMessage";

import NotificationSound from "../../audio/alert.mp3";
import userEvent from "@testing-library/user-event";

const limit = 1000;
const user = JSON.parse(localStorage.getItem("user"))?.data;
const ChatBox = () => {
  const audioPlayer = useRef(null);

  const [messageToSend, setMessageToSend] = useState("");
  const [isMessageLoading, setIsMessageLoading] = useState(false);

  const [offSet, setOffSet] = useState(0);

  const [feeds, setFeeds] = useState([]);
  const [lastFeed, setLastFeed] = useState(null);

  function playAudio() {
    audioPlayer.current.play();
  }

  const handleMessageChange = (data) => {
    setMessageToSend(data);
  };

  const handleSubmit = async () => {
    setIsMessageLoading(true);
    const res = await FeedsService.createFeeds({
      description: messageToSend,
    });
    setMessageToSend("");
    getData();
    setIsMessageLoading(false);
  };

  const getData = async () => {
    const res = await FeedsService.getAllFeeds(offSet, limit);
    // const resCount = await FeedsService.getFeedCount();

    setFeeds(res.data);
  };

  useEffect(() => {
    const interval = setInterval(() => getData(), 15000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    var newLastFeed = feeds[feeds.length - 1];

    if (feeds.length > 0 && (!lastFeed || lastFeed?.id !== newLastFeed?.id)) {
      setLastFeed((prev) => newLastFeed);
      lastFeed !== null && lastFeed?.employee !== user.id && playAudio();
    }
  }, [feeds]);

  useEffect(() => {
    const getData = async () => {
      const res = await FeedsService.getAllFeeds(offSet, limit);
      setFeeds((prev) => [...res.data, ...prev]);
    };
    getData();
  }, [offSet]);

  return (
    <Stack sx={{ height: "100%" }}>
      <Grid sx={{ height: "90%" }}>
        <ChatList
          feedList={feeds}
          limit={limit}
          loadMore={() => {
            setOffSet((prev) => prev + limit);
          }}
        />
      </Grid>
      <audio ref={audioPlayer} src={NotificationSound} />
      <Grid sx={{ height: "10%" }}>
        <SendMessage
          onSubmit={handleSubmit}
          handleChange={handleMessageChange}
          message={messageToSend}
          loading={isMessageLoading}
        />
      </Grid>
    </Stack>
  );
};

export default ChatBox;
